export const LEGALE_API_BASE_URL = process.env.REACT_APP_LEGALE_API_BASE_URL;
export const LEGALE_SOCKET_BASE_URL = process.env.REACT_APP_LEGALE_SOCKET_BASE_URL;
export const LEGALE_FRONTEND_BASE_URL = process.env.REACT_APP_LEGALE_FRONTEND_BASE_URL;

export const lsKeyToken = "__token";

export const msgFieldRequired = "This field is required";
export const msgFieldInvalid = "Invalid field";

export const msgMaintenanceMode =
  "Sorry, we are making an improvement to the system, we have incorporated new features and some security updates, give us a few more minutes to finish. Soon you will be able to enjoy them.";
export const msgNetworkError =
  "You have trouble in your internet connection, please verify and try again.";
export const msgUnauthorized = "Unauthorized";
export const msgNoPermission = "You have no permission.";
export const msgServiceNotFound = "Service not found.";
export const msgBadRequest = "Bad request.";
export const msgServiceError = "Service error.";
